import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=71ae5c41&"
import script from "./SocialAuth.vue?vue&type=script&lang=js&"
export * from "./SocialAuth.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuth.vue?vue&type=style&index=0&id=71ae5c41&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/app/components/UI/UiIcon.vue').default})
